import React from 'react'

import { Portlet, Row, Col, Button, Form } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as InventariosService from 'services/inventario.service'

import { SelectSede, SelectTipoExistencia } from 'sharedComponents/select'

import { DownloadAxiosFile } from 'utils'

const ReportexTipoOperacion = () => {
  const __zariContext = React.useContext(ZariContext)

  const [fechaDesde, setFechaDesde] = React.useState(new Date())
  const [fechaHasta, setFechaHasta] = React.useState(new Date())
  const [idSede, setIdSede] = React.useState('')
  const [tipoExistencia, setTipoExistencia] = React.useState('')
  const [resultados, setResultados] = React.useState(null)
  const [tiposOperacion, setTiposOperacion] = React.useState([])
  const [buscando, setBuscando] = React.useState(false)

  const getParams = () => ({ fechaDesde, fechaHasta, idSede, tipoExistencia })

  const clickDescargarReporte = React.useCallback(() => {
    __zariContext.loader.open('Descargando reporte por Tipo de Operación...')
    InventariosService.descargarReportexTipoOperacion(getParams())
      .then(({ data, headers }) => { DownloadAxiosFile.downloadAsBlob(data, headers) })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => { __zariContext.loader.close() })
  }, [fechaDesde, fechaHasta, idSede, tipoExistencia, __zariContext])

  const clickBuscar = React.useCallback(() => {
    setBuscando(true)
    InventariosService.consultaTipoOperacion(getParams())
      .then(({ data }) => {
        setResultados(data.datos || [])
        setTiposOperacion(data.tiposOperacion || [])
      })
      .catch(({ data }) => __zariContext.snack('error', data?.error || 'Error al consultar'))
      .finally(() => setBuscando(false))
  }, [fechaDesde, fechaHasta, idSede, tipoExistencia, __zariContext])

  const getNombreTipoOperacion = (codigo) => {
    const found = tiposOperacion.find(x => x.codigo === codigo)
    return found ? found.nombre : codigo
  }

  return (
    <Portlet>
      <Portlet.Header title='Reporte por Tipo de Operación' />
      <Portlet.Body>
        <Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='Desde' htmlFor='desde' md={4} />
              <Col md={6}>
                <Form.InputDate value={fechaDesde} name='fechaDesde' id='date-desde-to' onChange={e => setFechaDesde(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='Hasta' htmlFor='hasta' md={4} />
              <Col md={6}>
                <Form.InputDate value={fechaHasta} name='fechaHasta' id='date-hasta-to' onChange={e => setFechaHasta(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='ESTABLECIMIENTO' htmlFor='select-sede' md={4} alignRightAt='md' />
              <Col md={8}>
                <SelectSede id='select-sede-to' name='select-sede-to' value={idSede} onChange={e => setIdSede(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='T. EXISTENCIA' htmlFor='select-tipoExistencia' md={4} alignRightAt='md' />
              <Col md={8}>
                <SelectTipoExistencia id='select-tipoExistencia-to' name='select-tipoExistencia-to' value={tipoExistencia} onChange={e => setTipoExistencia(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={12} className='text-right'>
            <Button variant='outline-primary' onClick={clickBuscar} disabled={buscando} className='mr-2'>
              {buscando ? 'Buscando...' : 'Buscar'}
            </Button>
            <Button onClick={clickDescargarReporte}>Descargar Reporte</Button>
          </Col>
        </Row>

        {resultados && (
          <Row className='mt-3'>
            <Col md={12}>
              <div style={{ maxHeight: 500, overflowY: 'auto' }}>
                <table className='table table-sm table-striped table-bordered'>
                  <thead>
                    <tr>
                      <th>CODIGO</th>
                      <th>PRODUCTO</th>
                      <th>T. OPERACION</th>
                      <th className='text-right'>CANTIDAD</th>
                      <th className='text-right'>VALOR</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultados.map((r, i) => (
                      <tr key={i}>
                        <td>{r.codigo}</td>
                        <td>{r.nombre}</td>
                        <td>{getNombreTipoOperacion(r.tipoOperacion)}</td>
                        <td className='text-right'>{r.totalCantidad}</td>
                        <td className='text-right'>{r.totalValor}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <small className='text-muted'>{resultados.length} registros encontrados</small>
            </Col>
          </Row>
        )}
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(ReportexTipoOperacion)
